import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface PressReleaseRendererProps {
  data: any;
}

const PressReleaseRenderer: React.FC<PressReleaseRendererProps> = ({ data }) => {
  if (!data.headline) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <div className="text-sm text-gray-500">No press release content available</div>
      </div>
    );
  }

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-8 max-w-4xl">
      {/* Press Release Header */}
      <div className="text-center mb-8 border-b-2 border-gray-900 pb-6">
        {/* Headline */}
        <h1 className="text-2xl font-bold text-gray-900 mb-3 leading-tight">{data.headline}</h1>

        {/* Subheadline */}
        {data.subheadline && (
          <h2 className="text-lg text-gray-700 font-medium">{data.subheadline}</h2>
        )}
      </div>

      {/* Dateline */}
      <div className="text-sm font-semibold text-gray-900 mb-4">{data.dateline}</div>

      {/* Press Release Body */}
      <div className="space-y-4 text-gray-800 text-sm leading-relaxed prose prose-sm max-w-none">
        {/* Lead Paragraph */}
        <div>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{data.lead_paragraph}</ReactMarkdown>
        </div>

        {/* Body Paragraphs */}
        <div>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{data.body_paragraphs}</ReactMarkdown>
        </div>
      </div>

      {/* Boilerplate */}
      {data.boilerplate && (
        <div className="mt-6 pt-6 border-t border-gray-300">
          <div className="text-sm text-gray-800 prose prose-sm max-w-none">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{data.boilerplate}</ReactMarkdown>
          </div>
        </div>
      )}

      {/* Media Contact */}
      {data.media_contact && (
        <div className="mt-6 pt-6 border-t border-gray-300">
          <div className="text-sm text-gray-800">
            <div className="font-semibold mb-2">Media Contact:</div>
            <div>{data.media_contact.name}</div>
            <div>{data.media_contact.title}</div>
            <div>{data.media_contact.email}</div>
            <div>{data.media_contact.phone}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PressReleaseRenderer;
